import { z } from 'zod';

export const DatiqGeoSuggestionSchema = z.object({
    displayName: z.string(),
    pointId: z.number(), // NOTE: the results from the API use "placeId", but we alias this field to "pointId" using GraphQL to avoid breaking the interface
    latitude: z.number(),
    longitude: z.number(),
    city: z.string().optional(),
    stateProv: z.string().optional(),
    postalCode: z.string().optional(),
    county: z.string().optional(),
});

export interface IDatiqGeoSuggestion
    extends z.infer<typeof DatiqGeoSuggestionSchema> {}

export type IDatiqGeoSuggestionResponse = IDatiqGeoSuggestion[];

export const emptyDatiqGeoSuggestion: IDatiqGeoSuggestion = {
    displayName: '',
    pointId: -1,
    latitude: -1,
    longitude: -1,
};
